import { IStore, store as storeDefault } from '../utils/store';
import { createOfflineStorage } from '../offline-storage';
import { handleFeedbackCheck } from './handleFeedbackCheck';
import { createGaPush } from '../utils/createGaPush';
import { isHeaderEnabled } from 'src/store/isHeaderEnabled';

export async function bootstrap(
  store: IStore = storeDefault,
  global = window,
  localStorageInstance = localStorage
): Promise<void> {

  store.state.gaPush = createGaPush(global);

  if (isHeaderEnabled(global)) {
    store.state.gaPush({
      event: 'initial-meta',
      pageTemplate: 'standard',
      pageType: 'CONTENT',
      pageCategory1: 'Products',
      pageCategory2: 'RetroFIT+ Product Replacement Tool',
      currencyCode: 'USD',
      pageLanguage: store.state.currentLocale.substring(0, 2),
      pageLocale: store.state.currentLocale,
      loggedIn: false,
      anonymizeIP: true,
    });
  }

  const offlineStorage = createOfflineStorage(localStorageInstance);

  handleFeedbackCheck(store, offlineStorage)
    .then(() => console.log('feedback handler finished'))
    .catch((e) => console.error(e));
}
